export default __webpack_public_path__ + "static/media/farari.f6f004d7.jpg";